import React, { useState } from "react";
import { TestID } from "../testids/testids";
import { COREButton } from "../../COREDesignSystem/Action/COREButton";
import { COREModal } from "../../COREDesignSystem/Overlay/COREModal";
import { COREBody } from "../../COREDesignSystem/Typography/COREBody";
import { keysToSnake } from "../global";
import { AxiosResponse } from "axios";
import { useMutation } from "react-query";
import { coreMessage } from "../../COREDesignSystem/Feedback/COREMessage";
import { appQueryClient } from "../state/appQueryClient";

export type ReportUnlockModalProps = {
  testID: TestID;
  isOpen: boolean;
  closer: () => void;
  contentType: string[];
  requestedContentId: number;
};

export const ReportUnlockModal: React.FC<ReportUnlockModalProps> = ({
  testID,
  isOpen,
  closer,
  contentType,
  requestedContentId,
}) => {
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const sourceURL = window.location.href;

  const { mutate: verifyMutation } = useMutation<AxiosResponse<unknown>>(
    () => {
      return appQueryClient.fetchQuery({
        queryKey: [
          "reportUnlockRequest",
          {
            action: "reportUnlockRequest",
            body: JSON.stringify(
              keysToSnake({
                requestedContentId: requestedContentId,
                sourceUrl: sourceURL,
              })
            ),
            enabled: true,
          },
        ],
      });
    },
    {
      onSuccess: () => {
        closer();
        setIsSaving(false);
        return coreMessage({
          type: "success",
          content: "Request sent successfully.",
        });
      },
      onError: () => {
        closer();
        setIsSaving(false);
        return coreMessage({
          type: "error",
          content: "Request failed to send.",
        });
      },
    }
  );

  return (
    <COREModal
      destroyOnClose
      open={isOpen}
      testID={testID}
      onCancel={closer}
      type="basic"
      title="Unlock report"
      footer={[
        <COREButton
          size="lg"
          type="primary"
          block={true}
          key="request-unlock-button"
          onClick={() => {
            setIsSaving(true);
            verifyMutation();
          }}
          disabled={isSaving}
        >
          Request unlock
        </COREButton>,
      ]}
      width={384}
      footerFullWidth={true}
    >
      <COREBody type="p2" marginBottom={false}>
        Unlock the <strong>{contentType.join()}</strong>, upon payment the
        content will be delivered to your inbox. Our team will be in touch as
        soon as possible to complete the process.
      </COREBody>
    </COREModal>
  );
};
